import { motion } from 'motion/react'

import DraftItem from './DraftItem/DraftItem'
import DraftItemPlaceHolders from './DraftItemPlaceHolders/DraftItemPlaceHolders'
import * as Styles from './styles'

const DraftItemsList = ({
  draftItems,
  showHts,
  getHsDecision,
  getHtsDecision,
  onHsAccept,
  onHsDiscard,
  onHsUndo,
  onRestoreHs,
  onHtsAccept,
  onHtsDiscard,
  onHtsUndo,
  onRestoreHts,
}) => {
  if (!draftItems?.length) {
    return (
      <Styles.ScrollableContent>
        <DraftItemPlaceHolders />
      </Styles.ScrollableContent>
    )
  }

  return (
    <Styles.ScrollableContent>
      {draftItems.map((item, index) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: item.delay }}
        >
          <DraftItem
            item={item}
            showHts={showHts}
            hsDecision={getHsDecision(item.id)}
            htsDecision={getHtsDecision(item.id)}
            onHsAccept={onHsAccept}
            onHsDiscard={onHsDiscard}
            onHsUndo={onHsUndo}
            onRestoreHs={onRestoreHs}
            onHtsAccept={onHtsAccept}
            onHtsDiscard={onHtsDiscard}
            onHtsUndo={onHtsUndo}
            onRestoreHts={onRestoreHts}
            position={index + 1}
          />
        </motion.div>
      ))}
    </Styles.ScrollableContent>
  )
}

export default DraftItemsList
